import React, { useEffect, useState } from 'react';
import BreadCrumb from "../../../Components/Utils/Breadcrumbs";
import SearchBar from "../../../Components/Utils/SearchBar";
import { CreateButton } from "../../../Components/Utils/Buttons";
import DataTable from "../../../Components/Layouts/DataTable";
import { Link, useParams } from "react-router-dom";
import View from "../../../Components/Icons/View";
import Edit from "../../../Components/Icons/Edit";
import Delete from "../../../Components/Icons/Delete";
import axiosInstance from '../../../Services/axiosCommon';

function AssetsIndex() {
  const {officeId} =useParams();
  const [data, setData] = useState([]);
  async function getAssets() {
    const params = {
      page:1,
      per_page:20,
    };
    await axiosInstance
      .get(`/asset/`,{ params })
      .then(async (res) => {
        (await res?.data?.data) && setData(res?.data?.data.assetDetails);
        // setTotalSubs(res.data?.totalRecords);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(()=>{
    getAssets();
  },[]);

  let headers = [
    {
      label: <span>Ref</span>,
      width: "w-[7%]",
    },
    {
      label: <span>Asset Name</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Asset Type</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Asset Number</span>,
      width: "w-[7%]",
    },
    {
      label: <span>Purchase Amount</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Revaluation Date</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Revaluation Amount</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Asset Value</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Status</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Action</span>,
      width: "w-[10%]",
    },
  ];
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full h-[46px]  flex justify-between ">
        <BreadCrumb
          items={[
            { title: <p className=" text-[12px] ">Test</p> },
            { title: <p className=" text-[12px] ">Asset</p> },
          ]}
        />
        <div className=" flex gap-2">
          <SearchBar />
          <CreateButton label="Import" />
          <Link to="/main/asset/${officeId}/create">
            <CreateButton label="Asset" />
          </Link>
        </div>
      </div>

      <DataTable
        headers={headers}
        total={100}
        pageIndex={1}
        setPageIndex={() => {}}
        dataCount={20}
        setDataCount={() => {}}
      >
        {data.length > 0 ? (
          data.map((item, i) => {
            return (
              <tr
                className=" p-1 hover:scale-y-105 rounded-l-md hover:shadow-md"
                key={i}
              >
                <td className="w-[7%] py-3 my-6 text-center bg-white rounded-l-md ">
                  {item?.assetId || "-"}
                </td>
                <td className="w-[10%] p-2 text-center bg-white">
                  {item?.assetName || "-"}
                </td>
                <td className="w-[10%] p-2 text-center bg-white">
                  {item?.assetType || "-"}
                </td>
                <td className="w-[7%] p-2 text-center bg-white">
                  {item?.serialNumber || "-"}
                </td>
                {/* <td className="w-[15%] p-2 text-right ">test</td> */}
                <td className="w-[10%] p-2  text-center bg-white">
                  {item?.purchaseAmount || "0.00"}
                </td>
                <td className="w-[10%] p-2  text-center bg-white">
                  {item?.revaluationDate || "-"}
                </td>
                <td className="w-[10%] p-2  text-center bg-white">
                  {item?.revaluationAmount || "-"}
                </td>
                <td className="w-[10%] p-2  text-center bg-white">
                  {item?.valueOfAsset || "0.00"}
                </td>
                <td className="w-[10%] p-2  text-center bg-white">
                  {item?.status || "-"}
                </td>
                <td className="w-[10%] p-2 text-center bg-white rounded-r-md">
                  <div className=" w-full flex justify-center items-center gap-2">
                    <Link to={`/main/asset/${officeId}/view/${item?.assetId}`}>
                      <View />
                    </Link>
                    <Link to={`/main/asset/${officeId}/edit/${item?.assetId}`}>
                      <Edit />
                    </Link>
                    <Link>
                      <Delete />
                    </Link>
                  </div>
                </td>
              </tr>
            );
          })
        ) : (
          <tr className=" text-center my-2 font-semibold text-sm">
            <div className=" w-full h-[calc(100vh-240px)] rounded-md flex justify-center items-center bg-slate-300">
            No Data Found
            </div>
          </tr>
        )}
      </DataTable>
    </div>
  )
}

export default AssetsIndex;